import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import Skeleton from "@mui/material/Skeleton";
import "./DashboardCard.scss";

const DashboardCard = ({
  icon,
  value,
  label,
  isLoading,
  onClick,
}) => {
  const body = (
    <CardContent className="dashboard-card_inner">
      {icon && <div className="card-icon-container">{icon}</div>}
      <div className="dashboard-card_content">
        {isLoading ? (
          <Skeleton width={80} height={32} />
        ) : (
          <h2>{value}</h2>
        )}
        <h3>{label}</h3>
      </div>
    </CardContent>
  );

  return (
    <Card
      className="dashboard-card"
      elevation={0}
      sx={{ width: "100%", height: "100%", minWidth: 0 }}
    >
      {onClick ? (
        <CardActionArea onClick={onClick} sx={{ height: "100%", display: "flex" }}>
          {body}
        </CardActionArea>
      ) : (
        body
      )}
    </Card>
  );
};

export default DashboardCard;
